var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jFdG-76_seIEvf-hbjSsaa",
    x1: 1688.489,
    x2: 1685.469,
    y1: -883.003,
    y2: -881.443,
    gradientTransform: "matrix(11.64 0 0 22.55 -19615.32 19904.924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#047ed6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50e6ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jFdG-76_seIEvf-hbjSsaa)",
    fillRule: "evenodd",
    d: "M7.809,4.608c-0.45,0.483-0.708,1.227-0.708,2.194 v34.384c0,0.967,0.258,1.711,0.725,2.177l0.122,0.103L27.214,24.2v-0.433L7.931,4.505L7.809,4.608z",
    clipRule: "evenodd"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jFdG-76_seIEvf-hbjSsab",
    x1: 1645.286,
    x2: 1642.929,
    y1: -897.055,
    y2: -897.055,
    gradientTransform: "matrix(9.145 0 0 7.7 -15001.938 6931.316)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jFdG-76_seIEvf-hbjSsab)",
    fillRule: "evenodd",
    d: "M33.623,30.647l-6.426-6.428v-0.45l6.428-6.428 l0.139,0.086l7.603,4.321c2.177,1.227,2.177,3.249,0,4.493l-7.603,4.321C33.762,30.561,33.623,30.647,33.623,30.647z",
    clipRule: "evenodd"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jFdG-76_seIEvf-hbjSsac",
    x1: 1722.978,
    x2: 1720.622,
    y1: -889.412,
    y2: -886.355,
    gradientTransform: "matrix(15.02 0 0 11.5775 -25848.943 10324.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9414f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c193f"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jFdG-76_seIEvf-hbjSsac)",
    fillRule: "evenodd",
    d: "M33.762,30.561l-6.565-6.567L7.809,43.382 c0.708,0.761,1.9,0.847,3.232,0.103L33.762,30.561",
    clipRule: "evenodd"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "jFdG-76_seIEvf-hbjSsad",
    x1: 1721.163,
    x2: 1722.215,
    y1: -891.39,
    y2: -890.024,
    gradientTransform: "matrix(15.02 0 0 11.5715 -25848.943 10307.886)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33c481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61e3a7"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jFdG-76_seIEvf-hbjSsad)",
    fillRule: "evenodd",
    d: "M33.762,17.429L11.041,4.522 c-1.33-0.761-2.524-0.658-3.232,0.103l19.386,19.369L33.762,17.429z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.395d17019429f9b9b510795edde48acf.svg";
export { ForwardRef as ReactComponent };